module.exports = __webpack_public_path__ + "img/i_new2.312d6389.svg";